<template>
  <div class="flex justify-between items-center h-13 py-5 px-4">
    <a-tooltip
      v-for="item in alignOptions"
      :key="item.value"
      :title="item.tooltip"
    >
      <div
        class="p-[6px] transition-all opacity-30 hover:opacity-100"
        :class="{
          '  !opacity-100': value == item.value,
          ' !attr-disabled': disabled
        }"
        @click="
          () =>
            disabled
              ? showToast('自适应宽高下无法使用对齐方式')
              : emit('change', item.value)
        "
      >
        <Icon :icon="item.icon" :width="20" :height="20" fill="none" />
      </div>
    </a-tooltip>
  </div>
</template>

<script lang="ts" setup>
import showToast from '../toast';

const emit = defineEmits<{
  (event: 'change', val: string): void;
}>();

defineProps({
  value: {
    type: String,
    required: true
  },
  disabled: {
    type: Boolean,
    required: false
  }
});

const alignOptions: {
  icon: string;
  tooltip: string;
  value: 'left' | 'center' | 'right';
}[] = [
  {
    icon: 'alignLeft.svg',
    value: 'left',
    tooltip: '左对齐'
  },
  {
    icon: 'alignCenter.svg',
    value: 'center',
    tooltip: '居中对齐'
  },
  {
    icon: 'alignRight.svg',
    value: 'right',
    tooltip: '右对齐'
  }
];
</script>
